import React, { Fragment } from 'react';
import {
  compose,
  setDisplayName,
  withProps,
} from 'recompose';
import reactCSS from 'reactcss';
import Modal from '@ux/modal';
import AnimateHeight from 'react-animate-height';
import { Settings, SettingsToggle } from '../settings';
import Header from '../header';
import CookieToggleGroup from '../cookie-toggle-group';
import { Container } from '@ux/grid';
import { Content } from '@ux/typeface';
import Button, { Kind, Size } from '@ux/button';
import TextButton, { Against } from '@ux/text-button';
import { FormattedMessage } from 'react-intl';
import { breakpointConnect } from '@ux/responsive';
import { getStyles } from '@ux/style-utils';
import stylesheet from './PrivacyModal.stylesheet';
import { Field, Form } from 'redux-form';
import * as r from 'ramda';

const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  tablet: props.isMinMd,
  desktop: props.isMinLg,
});

export const PurePrivacyModal = ({
  styles,
  expanded,
  theme,
  isMinMd,
  isMinLg,
  cookies,
  form,
  privacyPolicyUrl,
  buttonSize,
  isOpen,
}) => (
  <Modal
    theme={theme}
    isOpen={isOpen}
  >
    <Content
      key="privacy"
      theme={theme}
      component="div"
      className="UPM__PrivacyModal"
    >
      <div style={styles.inner}>
        <Form onSubmit={form.handleSubmit}>
          <Container theme={theme}>
            <div style={styles.header}>
              <Header
                theme={theme}
                intlNamespace="modal"
                expanded={expanded}
                privacyPolicyUrl={privacyPolicyUrl}
              />
            </div>
            <div style={styles.settings}>
              <Settings
                theme={theme}
                expanded={expanded}
                isMinMd={isMinMd}
                isMinLg={isMinLg}
              >
                <CookieToggleGroup
                  theme={theme}
                  cookies={cookies}
                  isMinMd={isMinMd}
                  lgCols={6}
                />
              </Settings>
            </div>
            <div style={styles.actions}>
              <span style={styles.decline}>
                <Field
                  name="submit"
                  component={({ input }) => (
                    <TextButton
                      theme={theme}
                      against={Against.NEUTRAL}
                      size={buttonSize}
                      onClick={() => {
                        input.onChange('decline');
                      }}
                    >
                      <FormattedMessage id="cookie.decline"/>
                    </TextButton>
                  )}
                />
              </span>
              <div style={styles.buttons}>
                <Field
                  name="expanded"
                  component={({ meta, input }) => (
                    <SettingsToggle
                      buttonSize={buttonSize}
                      theme={theme}
                      expanded={input.value}
                      onClick={() => input.onChange(r.not(input.value)) }
                    />
                  )}
                />
                <span style={styles.spacer}/>
                <Field
                  name="submit"
                  component={({ input }) => (
                    <Button
                      type="submit"
                      theme={theme}
                      kind={Kind.POSITIVE}
                      size={buttonSize}
                      onClick={() => {
                        input.onChange('accept');
                      }}
                    >
                      {r.ifElse(
                        r.equals(true),
                        () => (
                          <FormattedMessage id="cookie.confirm"/>
                        ),
                        () => (
                          <FormattedMessage id="cookie.accept"/>
                        ),
                      )(expanded)}
                    </Button>
                  )}
                />
              </div>
            </div>
          </Container>
        </Form>
      </div>
    </Content>
  </Modal>
);

export const enhance = compose(
  setDisplayName('PrivacyModal'),
  breakpointConnect([
    'isMinMd',
    'isMinLg',
  ]),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
    buttonSize: r.ifElse(
      r.propEq('isMinLg', true),
      r.always(Size.MD),
      r.always(Size.SM),
    )(ownerProps),
  })),
);

export default enhance(PurePrivacyModal);



// WEBPACK FOOTER //
// ./src/presentation/components/privacy-modal/PrivacyModal.js